import React, { useState } from 'react';
import { BookModel, SiteSettingModel } from '../../../../models';
import BookList from './BookList';
import BookRegistration from './BookRegistration';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface BookManagementProps {
  books: BookModel[];
  siteSettings: SiteSettingModel;
  editingBook: BookModel | null;
  onEditBook: (book: BookModel) => void;
  onDeleteBook: (book: BookModel) => void;
  onSubmit: (book: BookModel) => void;
  onCancelEdit: () => void;
  currentUserId?: string;
  currentUserRole?: string;
  branchId?: string;
}

const BookManagement: React.FC<BookManagementProps> = ({
  books,
  siteSettings,
  editingBook,
  onEditBook,
  onDeleteBook,
  onSubmit,
  onCancelEdit,
  currentUserId,
  currentUserRole,
  branchId
}) => {
  const [isListCollapsed, setIsListCollapsed] = useState(false);

  return (
    <div className="flex flex-col h-full bg-white overflow-hidden">
      <div className="flex-1 flex overflow-hidden bg-slate-50 relative">
        {/* Left Pane: Book List */}
        <div className={`transition-all duration-300 flex flex-col h-full bg-white ${isListCollapsed ? 'w-0 overflow-hidden border-r-0 opacity-0' : 'w-[280px] border-r border-slate-200 opacity-100'}`}>
          <BookList
            books={books}
            siteSettings={siteSettings}
            onDeleteBook={onDeleteBook}
            onEditBook={onEditBook}
            selectedBookId={editingBook?.id}
            currentUserId={currentUserId}
            currentUserRole={currentUserRole}
          />
        </div>

        {/* Right Pane: Registration Form */}
        <div className="flex-1 overflow-hidden p-0 pt-0 bg-white relative">
          <div className="w-full h-full">
            <BookRegistration
              onSubmit={onSubmit}
              siteSettings={siteSettings}
              editingBook={editingBook}
              onCancelEdit={onCancelEdit}
              branchId={branchId}
              isListCollapsed={isListCollapsed}
            />
          </div>
        </div>

        {/* Toggle Button */}
        <button
          onClick={() => setIsListCollapsed(!isListCollapsed)}
          style={{ left: isListCollapsed ? '12px' : '280px' }}
          className="absolute top-20 -translate-x-1/2 z-50 w-5 h-8 rounded-md bg-white border border-slate-200 hover:bg-slate-100 hover:text-indigo-600 text-slate-400 shadow-sm transition-all duration-300 flex items-center justify-center cursor-pointer active:scale-95 select-none"
          title={isListCollapsed ? "교재 목록 펼치기" : "교재 목록 접기"}
        >
          {isListCollapsed ? <ChevronRight size={10} strokeWidth={3} /> : <ChevronLeft size={10} strokeWidth={3} />}
        </button>
      </div>
    </div>
  );
};

export default BookManagement;
